@if (this.title(); as title) {
  <div class="mb-space-md space-between align-center">
    <cam-title [level]="3" [isBold]="true">{{ title | translate }}</cam-title>
  </div>
}

@if (this.isEditable() === true) {
  <cam-grid-expandable [gridId]="this.gridId()">
    <div class="space-between">
      <cam-grid-tag controls class="d-flex" [gridId]="this.gridId()"></cam-grid-tag>
      <cam-grid-control
        controls
        class="d-flex"
        [gridId]="this.gridId()"
        [show]="{ expand: true, flatView: true, showHidden: true, shortcuts: true }"
      ></cam-grid-control>
    </div>

    <cam-ag-grid-editabled
      [gridId]="this.gridId()"
      [services]="this.editable()"
      [colsMetaData]="this.colsMetaData()"
      [fieldsOverrides]="this.fieldsOverrides()"
      [treeData]="this.treeData"
    ></cam-ag-grid-editabled>
    <cam-ag-grid-footer [gridId]="this.gridId()" [services]="this.footer()"></cam-ag-grid-footer>
  </cam-grid-expandable>
} @else if (this.isEditable() === false) {
  <div class="content mb-space-md flex-column">
    <div class="space-between">
      <cam-grid-tag class="d-flex" [gridId]="this.classicGridId()"></cam-grid-tag>
      <cam-grid-control
        class="d-flex"
        [gridId]="this.classicGridId()"
        [show]="{ filters: true, views: true, fields: true, search: true, switchView: false }"
      ></cam-grid-control>
    </div>
  </div>
  <cam-loader [isLoading]="this.requestState.isLoading()">
    <cam-error [message]="this.requestState.getErrorMessage()" [code]="this.requestState.getErrorStatus()">
      <cam-ag-grid
        defaultDisplay="grid"
        [gridId]="this.classicGridId()"
        [colsMetaData]="this.colsMetaData()"
        [services]="this.classic()"
        [fieldsOverrides]="this.fieldsOverrides()"
        [treeData]="this.classicTreeData"
      ></cam-ag-grid>
    </cam-error>
  </cam-loader>
  <cam-ag-grid-footer [gridId]="this.classicGridId()" [services]="this.footer()"></cam-ag-grid-footer>
}
